<div class="modal-content demeter-gdpr-modal">
  <!-- Personal Data Protection Section -->
  <div class="modal-header">
    <h5 class="modal-title">Disclaimer and Personal Data Protection</h5>
  </div>

  <div class="gdpr-scroll-warning" style="color: #b85c00; background: #fffbe6; border: 1px solid #ffe58f; border-radius: 4px; padding: 8px 12px; margin: 18px 18px 18px 18px; font-size: 0.97em;">
    <strong>Note:</strong> Scroll to the bottom to review all personal data protection information. At the end, you will have the option to accept the terms.
  </div>

   <div class="gdpr-content" style="padding: 24px;">
    <div class="gdpr-heading">
      <div class="gdpr-main-title">Disclaimer - Test Version</div>
    </div>
    <p class="gdpr-consent-text" style="margin-bottom: 18px;">
      EUROCONTROL provides no express or implied warranty of any kind, including but not limited to those of compatibility, title, accuracy, merchantability and fitness for a particular purpose, and accepts no liability whatsoever for or in connection with the use of GRIT.
      The user is entirely liable for the utilization of GRIT or parts thereof for any safety-critical decisions.
    </p>
    <div class="gdpr-consent-box">
      <div class="form-check gdpr-checkbox-area">
        <input
          class="form-check-input gdpr-checkbox"
          type="checkbox"
          id="testDisclaimerCheck"
          [(ngModel)]="testDisclaimerChecked"
        />
        <label class="form-check-label gdpr-checkbox-label" for="testDisclaimerCheck">
          I acknowledge and accept the terms of the above disclaimer regarding the use of this test version of GRIT, including all limitations of warranty and liability.
        </label>
      </div>
    </div>
  </div>

  <hr class="gdpr-separator" />
  <div class="modal-body" style="max-height: 365px; ">
    <div class="gdpr-content">
      <div class="gdpr-heading">
        <div class="gdpr-main-title">PRIVACY STATEMENT ON THE PROTECTION OF PERSONAL DATA</div>
        <div class="gdpr-subtitle">GRIT</div>
      </div>
      <div class="gdpr-text">
        <p>
          EUROCONTROL protects your personal data in accordance with the EUROCONTROL
          Regulation on Personal Data Protection adopted by its Member States,
          Office Notice 34/08 of 2.7.2008, and its Implementing Rules which were
          published by Office Notice 25/17 of 25.10.2017.
        </p>
        <div class="gdpr-section">
          <div class="gdpr-section-title">1. What is GRIT? Why do we collect, store and process your data?</div>
         <p>
            Global Navigation Satellite System Radio Frequency Interference Testing (GRIT) is a tool that allows users to plan, design, coordinate and execute Global Navigation Satellite System (GNSS) interference tests while minimising their impact on aviation operations. The tool also provides collaborative decision-making and awareness of interference exercises.
          </p>

          <p>The main capabilities of GRIT include:</p>

          <ul>
            <li>Design of GNSS interference testing events for both jamming and spoofing.</li>
            <li>Graphical display of planned GNSS testing events.</li>
            <li>Risk analysis and impact assessment of GNSS interference.</li>
            <li>Streamlined workflows with defined roles, responsibilities and cross-border coordination.</li>
            <li>Automated generation of publication proposals (NOTAM/AIP SUP).</li>
            <li>Awareness of testing exercises across civil and military entities.</li>
            <li>Support for adherence to the EUROCONTROL Guidelines on a Process for Civil and Military GNSS Interference Testing.</li>
          </ul>
          <p>
            The personal data processing is related to licensing and distribution of the application
            to external users. It allows to maintain a database of users as well as to track and
            manage the associated licenses. The personal data (i.e. email address) is used to
            distribute messages of interest for all users, e.g. availability of new releases.
          </p>
        </div>
        <div class="gdpr-section">
          <div class="gdpr-section-title">2. What data do we collect, store and process about you?</div>
          <p>
            We hold the following categories of data related to you:
            Name, Country, Organization Name, Organization Type, Job Title and email address.
          </p>
        </div>
        <div class="gdpr-section">
          <div class="gdpr-section-title">3. Who is your data disclosed to? Who has access to your data?</div>
          <p>
            Your personal data is only available to EUROCONTROL personnel who maintain, distribute
            and provide user support for GRIT.
          </p>
        </div>
        <div class="gdpr-section">
          <div class="gdpr-section-title">4. How long is your data kept?</div>
          <p>
            The information is deleted when a user leaves the organisation or changes job position
            and the change is notified to EUROCONTROL by sending a request to
            <span class="linkish">milcns@eurocontrol.int</span> or when the license agreement
            expires or is terminated.
          </p>
        </div>
        <div class="gdpr-section">
          <div class="gdpr-section-title">5. What are your rights under the EUROCONTROL Data Protection Regulation?</div>
          <p>
            You have the right to request additional information about the handling of your personal
            data and to access, rectify, complete and update your data by contacting
            <span class="linkish">milcns@eurocontrol.int</span>.
          </p>
        </div>
        <div class="gdpr-section">
          <div class="gdpr-section-title">6. What do we do to avoid misuse or unauthorised access to data concerning you?</div>
          <p>
            EUROCONTROL is committed to ensuring that your information is secure. In order to prevent
            unauthorised access or disclosure EUROCONTROL has put in place suitable physical,
            electronic and managerial procedures to safeguard and secure the information collected
            from you.
          </p>
        </div>
        <div class="gdpr-section">
          <div class="gdpr-section-title">7. What safeguards do we apply when we transfer your data to third parties?</div>
          <p>
            We will not, under any circumstances, share with or sell your personal information to
            any third party for marketing purposes, and you will not receive offers from other
            companies or organisations as a result of giving your details to us.
          </p>
        </div>
        <div class="gdpr-section">
          <div class="gdpr-section-title">8. How can you contact if you have questions or want to make a complaint?</div>
          <p>
            For any queries related to the use of your personal data, please contact:
            <span class="linkish">milcns@eurocontrol.int</span>
          </p>
          <p>
            Complaints can be addressed to EUROCONTROL’s
            <span class="linkish">Data Protection Officer</span>.
          </p>
        </div>
      </div>
      <hr class="gdpr-separator" />
      <div class="gdpr-consent-box">
        <div class="form-check gdpr-checkbox-area">
        <input
          class="form-check-input gdpr-checkbox"
          type="checkbox"
          id="gdprCheck"
          [(ngModel)]="consentChecked"
        />
        <label class="form-check-label gdpr-checkbox-label" for="gdprCheck">
          I acknowledge and accept the terms of the above privacy statement regarding the processing of my data in accordance with the GDPR policy.
        </label>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary gdpr-accept-button"
      [disabled]="!(consentChecked && testDisclaimerChecked)"
      (click)="onClose()"
    >
      Accept
    </button>
  </div>
</div>
